import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Fechar Caixa", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_4 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "ant-col ant-col-xs-5 ant-col-xl-5"
}
const _hoisted_7 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_8 = { class: "ant-col ant-col-xs-7 ant-col-xl-7" }
const _hoisted_9 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_11 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_12 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"10px","margin-bottom":"0px"}
}, null, -1)
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_17 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_18 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_19 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_20 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_detalhes_abertura_caixa = _resolveComponent("detalhes-abertura-caixa")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Fechamento de Caixa",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 900,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-financeiro':'ss-modal-financeiro'
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmarFechamento && _ctx.confirmarFechamento(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_detalhes_abertura_caixa, {
                empresa: _ctx.props.empresa,
                abertura: _ctx.props.abertura
              }, null, 8, ["empresa", "abertura"]),
              (_ctx.state.fechamento.aberturasAnterioresPendentes.length > 0)
                ? (_openBlock(), _createBlock(_component_a_collapse, {
                    key: 0,
                    ghost: "",
                    class: "ss-accordion"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse_panel, {
                        class: "ss-accordion",
                        header: "ABERTURAS ANTERIORES PENDENTES QUE TAMBÉM SERÃO FECHADAS",
                        style: {"overflow-y":"auto","max-height":"250px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.fechamento.aberturasAnterioresPendentes, (abertura, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "ant-row",
                              key: abertura.codigo
                            }, [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_a_form_item, {
                                  label: "Data",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_data, {
                                      "hora-minuto-segundo": true,
                                      dataSelecionada: abertura.dataAbertura,
                                      disabled: true
                                    }, null, 8, ["dataSelecionada"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_a_form_item, {
                                  label: "Operadores",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      type: "text",
                                      class: "ant-input",
                                      value: abertura.nomeOperador,
                                      disabled: ""
                                    }, null, 8, _hoisted_5)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (index === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Saldo Inicial",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          valor: abertura.saldoInicial,
                                          disabled: ""
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_a_form_item, {
                                  label: "Total de Movimentações",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      valor: abertura.totalMovimentacoes,
                                      disabled: ""
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    class: "ss-accordion",
                    header: "TRANSFERÊNCIAS APÓS O FECHAMENTO",
                    style: {"overflow-y":"auto","max-height":"250px"}
                  }, {
                    default: _withCtx(() => [
                      (_ctx.state.fechamento.transferencias.length === 0)
                        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                            key: 0,
                            mensagem: "Nenhuma transferência adicionada, todo saldo final ficará como saldo para a próxima abertura."
                          }))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.fechamento.transferencias, (transferencia, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "ant-row",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_selecionar_conta, {
                                  title: "Conta de Destino",
                                  empresas: [_ctx.props.empresa],
                                  codigoSelecionado: _ctx.state.fechamento.transferencias[index].codigoConta,
                                  "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.fechamento.transferencias[index].codigoConta) = $event)
                                }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_a_form_item, {
                                  label: "Categoria de Origem",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_categoria_plano_conta, {
                                      empresas: [_ctx.props.empresa],
                                      "codigo-selecionado": _ctx.state.fechamento.transferencias[index].codigoPlanoContaCategoriaOrigem,
                                      "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.fechamento.transferencias[index].codigoPlanoContaCategoriaOrigem) = $event)
                                    }, null, 8, ["empresas", "codigo-selecionado", "onUpdate:codigoSelecionado"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_a_form_item, {
                                  label: "Categoria de Destino",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_categoria_plano_conta, {
                                      empresas: [_ctx.props.empresa],
                                      "codigo-selecionado": _ctx.state.fechamento.transferencias[index].codigoPlanoContaCategoriaDestino,
                                      "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.state.fechamento.transferencias[index].codigoPlanoContaCategoriaDestino) = $event)
                                    }, null, 8, ["empresas", "codigo-selecionado", "onUpdate:codigoSelecionado"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_a_form_item, {
                                  label: "Valor",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      valor: _ctx.state.fechamento.transferencias[index].valor,
                                      "onUpdate:valor": [($event: any) => ((_ctx.state.fechamento.transferencias[index].valor) = $event), _ctx.calcularTotalTransferencias]
                                    }, null, 8, ["valor", "onUpdate:valor"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_a_form_item, {
                                  label: " ",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                                      onClick: ($event: any) => (_ctx.excluirTransferencia(index))
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_13)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]))
                          }), 128)),
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: " ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.adicionarTransferencia && _ctx.adicionarTransferencia(...args)))
                              }, "Adicionar Transferência")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Saldo Inicial",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.aberturaCaixa.saldoInicial,
                                disabled: ""
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_form_item, {
                            label: "Movimentações",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.aberturaCaixa.totalEntradas - _ctx.state.aberturaCaixa.totalSaidas,
                                disabled: ""
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_form_item, {
                            label: "Saldo Final",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.aberturaCaixa.saldoFinal,
                                disabled: ""
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_a_form_item, {
                            label: "Fundo Mínimo",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.props.caixa.fundoCaixaMinimo,
                                disabled: ""
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "Transferências",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.state.totalTransferencias,
                                "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.totalTransferencias) = $event)),
                                disabled: ""
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}